import { client } from 'pioneira-ui';
// import router from '@/router';

function getNotaFiscalVazia() {
  return {
    info_nota_fiscal: {
      situacao: '',
      arquivos: []
    }
  };
}

export default {
  namespaced: true,
  state: {
    loading: false,
    messages: [],
    dates: [],
    tipoResposta: 'error',
    mensagem: 'null',
    search: '',
    notasFiscaisPendentesDevolvidas: {
      loading: false,
      options: {
        itemsPerPage: 3,
        page: 1,
        totalRegisters: 0,
      },
      data: [],
    },
    notasFiscaisEnviadas: {
      loading: false,
      options: {
        itemsPerPage: 3,
        page: 1,
        totalRegisters: 0,
      },
      data: [],
    },
    notasFiscaisCanceladas: {
      loading: false,
      options: {
        itemsPerPage: 3,
        page: 1,
        totalRegisters: 0,
      },
      data: [],
    },
    notasFiscaisAceitas: {
      loading: false,
      options: {
        itemsPerPage: 3,
        page: 1,
        totalRegisters: 0,
      },
      data: [],
    },
    notaFiscal: {
      loading: false,
      data: getNotaFiscalVazia(),
    },
  },

  // getters: {
  //   notaPendenteDevolvida(state, payload = data) {
  //     return state.notasFiscaisPendentesDevolvidas[payload];
  //   },
  // },

  mutations: {
    SET_MENSAGEM(state, payload) {
      state.mensagem = payload;
    },

    SET_TIPO_RESPOSTA(state, payload) {
      state.tipoResposta = payload;
    },

    SET_NOTA_FISCAL_DATA(state, payload) {
      state.notaFiscal.data = payload;
    },

    CLEAR_DATA(state) {
      state.notaFiscal.data = getNotaFiscalVazia();
      state.loading = false;

      state.messages = [];
      state.notasFiscaisPendentesDevolvidas.data = [];
      state.notasFiscaisPendentesDevolvidas.options = {
        perPage: 3,
        page: 1,
        totalRegisters: 0,
      };
      state.notasFiscaisEnviadas.data = [];
      state.notasFiscaisEnviadas.options = {
        perPage: 3,
        page: 1,
        totalRegisters: 0,
      };
      state.notasFiscaisCanceladas.data = [];
      state.notasFiscaisCanceladas.options = {
        perPage: 3,
        page: 1,
        totalRegisters: 0,
      };
      state.notasFiscaisAceitas.data = [];
      state.notasFiscaisAceitas.options = {
        perPage: 3,
        page: 1,
        totalRegisters: 0,
      };
    },
    CLEAR_INPUT_DATA(state) {
      state.dates = [];
      state.search = '';
    },
  },

  actions: {
    setMensagem(context, payload) {
      context.commit('SET_MENSAGEM', payload);
    },

    setTipoResposta(context, payload) {
      context.commit('SET_TIPO_RESPOSTA', payload);
    },

    async getNotasFiscaisPendentesDevolvidas(context, payload) {
      context.state.notasFiscaisPendentesDevolvidas.data = [];

      await client
        .get('/api/notas-fiscais/pendente', {
          params: {
            itemsPerPage:
              context.state.notasFiscaisPendentesDevolvidas.options
                .itemsPerPage,
            page: context.state.notasFiscaisPendentesDevolvidas.options.page,
            search: payload ? payload.search : '',
            start_date: payload ? payload.start_date : '',
            end_date: payload ? payload.end_date : '',
          },
        })
        .then(({ data }) => {
          context.state.tipoResposta = 'success';
          context.state.notasFiscaisPendentesDevolvidas.data =
            data.data.notasFiscaisPendentesDevolvidas.data;
          context.state.notasFiscaisPendentesDevolvidas.options = {
            itemsPerPage: data.data.notasFiscaisPendentesDevolvidas.per_page,
            page: data.data.notasFiscaisPendentesDevolvidas.current_page,
            totalRegisters: data.data.notasFiscaisPendentesDevolvidas.total,
          };

          if (data.data && data.data.message) {
            context.state.mensagem = error.response.data.message;
          } else {
            context.state.mensagem = '';
          }
        })
        .catch((error) => {
          context.state.tipoResposta = 'error';

          if (error.response && error.response.data && error.response.data.message) {
            context.state.mensagem = error.response.data.message;
          } else {
            context.state.mensagem = 'Ocorreu um erro no CSC.';
          }
        });
    },

    getNotasFiscaisAceitas(context, payload) {
      client
        .get('/api/notas-fiscais/aceita', {
          params: {
            itemsPerPage:
              context.state.notasFiscaisAceitas.options.itemsPerPage,
            page: context.state.notasFiscaisAceitas.options.page,
            search: payload ? payload.search : '',
            start_date: payload ? payload.start_date : '',
            end_date: payload ? payload.end_date : '',
          },
        })
        .then(({ data }) => {
          context.state.notasFiscaisAceitas.data =
            data.data.notasFiscaisAceitas.data;
          context.state.notasFiscaisAceitas.options = {
            itemsPerPage: data.data.notasFiscaisAceitas.per_page,
            page: data.data.notasFiscaisAceitas.current_page,
            totalRegisters: data.data.notasFiscaisAceitas.total,
          };
        })
        .catch((error) => {
          context.state.tipoResposta = 'error';

          if (error.response && error.response.data && error.response.data.message) {
            context.state.mensagem = error.response.data.message;
          } else {
            context.state.mensagem = 'Ocorreu um erro no CSC.';
          }
        });
    },

    getNotasFiscaisEnviadas(context, payload) {
      client
        .get('/api/notas-fiscais/enviada', {
          params: {
            itemsPerPage:
              context.state.notasFiscaisEnviadas.options.itemsPerPage,
            page: context.state.notasFiscaisEnviadas.options.page,
            search: payload ? payload.search : '',
            start_date: payload ? payload.start_date : '',
            end_date: payload ? payload.end_date : '',
          },
        })
        .then(({ data }) => {
          context.state.tipoResposta = 'success';
          context.state.notasFiscaisEnviadas.data =
            data.data.notasFiscaisEnviadas.data;
          context.state.notasFiscaisEnviadas.options = {
            itemsPerPage: data.data.notasFiscaisEnviadas.per_page,
            page: data.data.notasFiscaisEnviadas.current_page,
            totalRegisters: data.data.notasFiscaisEnviadas.total,
          };

          if (data.data && data.data.message) {
            context.state.mensagem = error.response.data.message;
          } else {
            context.state.mensagem = '';
          }
        })
        .catch((error) => {
          context.state.tipoResposta = 'error';

          if (error.response && error.response.data && error.response.data.message) {
            context.state.mensagem = error.response.data.message;
          } else {
            context.state.mensagem = 'Ocorreu um erro no CSC.';
          }
        });
    },

    getNotasFiscaisCanceladas(context, payload) {
      client
        .get('/api/notas-fiscais/cancelada', {
          params: {
            itemsPerPage:
              context.state.notasFiscaisCanceladas.options.itemsPerPage,
            page: context.state.notasFiscaisCanceladas.options.page,
            search: payload ? payload.search : '',
            start_date: payload ? payload.start_date : '',
            end_date: payload ? payload.end_date : '',
          },
        })
        .then(({ data }) => {
          context.state.tipoResposta = 'success';
          context.state.notasFiscaisCanceladas.data =
            data.data.notasFiscaisCanceladas.data;
          context.state.notasFiscaisCanceladas.options = {
            itemsPerPage: data.data.notasFiscaisCanceladas.per_page,
            page: data.data.notasFiscaisCanceladas.current_page,
            totalRegisters: data.data.notasFiscaisCanceladas.total,
          };
          
          if (data.data && data.data.message) {
            context.state.mensagem = error.response.data.message;
          } else {
            context.state.mensagem = '';
          }
        })
        .catch((error) => {
          context.state.tipoResposta = 'error';

          if (error.response && error.response.data && error.response.data.message) {
            context.state.mensagem = error.response.data.message;
          } else {
            context.state.mensagem = 'Ocorreu um erro no CSC.';
          }
        });
    },

    async sendGroupNotas(context, payload) {
      const propostas = payload.map(Number);

      return await client
        .post('/api/nota-fiscal/agrupar', {
          propostas: propostas,
        });
    },

    async sendUnGroupNotas(context, payload) {
      const propostas = payload.propostas.split(',').map(Number);
      const $url = '/api/nota-fiscal/' + payload.id + '/desagrupar';

      return await client
        .put($url, {
          propostas: propostas,
        });
    },

    async setNotaFiscalData(context, payload) {
      context.commit('SET_NOTA_FISCAL_DATA', payload);
    },

    async getNotasFiscal(context, payload) {
      context.commit('SET_NOTA_FISCAL_DATA', getNotaFiscalVazia());
      const url = '/api/nota-fiscal/' + payload;

      return client
        .get(url, {
          params: {
            itemsPerPage:
              context.state.notasFiscaisPendentesDevolvidas.options
                .itemsPerPage,
            page: context.state.notasFiscaisPendentesDevolvidas.options.page,
          },
        });
    },

    updateNotaFiscal({ state }, data) {
      const formData = new FormData();

      if (data.issqnAliquota && data.issqnAliquota !== 'Não Retém') {
        formData.append('aliquota_issqn', parseFloat(data.issqnAliquota).toFixed(2));
      }

      formData.append('arquivo', data.file);
      formData.append('_method', 'PATCH');

      return client.post(`/api/nota-fiscal/${data.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
  },
};
